// Frontend keeps only static constants. Product data is fetched from /api/products.
export const PRODUCT_CATEGORIES = [
  "All",
  "Soup Range",
  "Rice Range",
  "Street Food Range",
  "Essentials",
  "Custom Solutions",
];

export const QUALITY_STANDARDS = [
  "100% Compostable",
  "PFAS Free",
  "Food Grade Certified",
  "Microwave Safe",
  "Oil & Water Resistant",
  "Strong & Leak Proof",
];
